<template>
  <div
    class="i-base-copy-text"
    @click="copyText"
  >
    <div class="text">{{ props.text }}</div>
    <img :src="iconCopy" />
  </div>
</template>

<script setup lang="ts">
// ASSETS
import iconCopy from "@/assets/icons/icon-copy.svg"

// PROPS
const props = defineProps({
  text: {
    type: String,
    required: true
  }
})

// FUNCTIONS
const copyText = () => {
  navigator.clipboard.writeText(props.text)
}
</script>

<style scoped lang="scss">
.i-base-copy-text {
  @include border-radius-sm;
  @include flex(row, start, center, $gap: 10px);

  width: fit-content;
  cursor: pointer;

  img {
    display: none;
    width: 17px;
  }

  &:hover {
    filter: brightness(85%);
    text-decoration: underline;

    img {
      display: block;
    }
  }
}
</style>
